import React from 'react';
import styled from 'styled-components';
import CountUp from 'react-countup';

import { Paper, Typography, Divider } from '@material-ui/core';

import IconArrow from '../../assets/icon-arrow.svg';

const Root = styled(Paper)`
	height: 100%;
	padding: 20px;
	cursor: pointer;

	.tile-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 20px;

		h5 {
			font-size: 16px;
			font-weight: bold;
			text-transform: uppercase;
		}

		img {
			width: 30px;
		}
	}

	.tile-content {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	hr {
		width: 60%;
	}
`;

const ColorFont = styled.span`
	display: inline-block;
	margin: 10px 0;
	font-size: 34px;
	font-weight: bold;
	color: ${(props) => props.theme.palette.text.primary};
	background-image: ${(props) => props.theme.palette.text.gradient};
	background-clip: text;
	-webkit-background-clip: text;
	-moz-background-clip: text;
	-moz-text-fill-color: transparent;
	-webkit-text-fill-color: transparent;
`;

const TilePotentielleErsparnisEigenverbrauch = ({ data, toggleModal, co2Data }) => (
	<Root onClick={toggleModal}>
		<div className="tile-head">
			<Typography variant="h5">Potentielle Einsparung</Typography>
			<img src={IconArrow} alt="" />
		</div>
		<div className="tile-content">
			<ColorFont>
				<CountUp end={data} duration={3} separator="." suffix=" €" />
			</ColorFont>
			<Divider />
			<ColorFont>
				<CountUp end={co2Data} duration={3} suffix=" t CO<sub>2</sub>" />
			</ColorFont>
		</div>
		{/* <Grid justify="space-between" container spacing={10} alignItems="center">
			<Grid item>
				<Typography
					variant="body1"
					style={{ fontWeight: '700', textTransform: 'uppercase' }}
				>
					Potentielle Einsparung
				</Typography>
			</Grid>
			<Grid item>
				<img src={IconLinkArrow} alt="IconLinkArrow" />
			</Grid>
		</Grid>

		<Grid
			container
			direction="column"
			justify="center"
			alignItems="center"
			alignContent="center"
			style={{ minHeight: '100%' }}
		>
			<Grid item>
				<ColorFont>
					<CountUp end={data} duration={3} separator="." suffix=" €" />
				</ColorFont>
			</Grid>

			<Grid item>
				<Divider />
				<ColorFont>
					<CountUp end={co2Data} duration={3} suffix=" t CO<sub>2</sub>" />
				</ColorFont>
			</Grid>
		</Grid> */}
	</Root>
);

export default TilePotentielleErsparnisEigenverbrauch;
